export const urlIsInternal = (url: string): boolean =>
	url.indexOf("/") === 0 && url.indexOf("//") === -1 && url.indexOf("#") === -1

export const urlIsToFile = (url: string): boolean => url.match(/\.[a-zA-Z0-9]+$/g) !== null